import React from 'react';

import { ServicePageContainer } from '../../../components';
import { services } from '../../../utils/constants';
import './CommercialCarpetCleaningPage.scss';

function CommercialCarpetCleaningPage() {
  return (
    <ServicePageContainer service={services[5]} />
  );
}

export default CommercialCarpetCleaningPage;